import React, { Component, Fragment } from "react"
import { Formik, Form, Field } from "formik"
import { withRouter } from "../../helpers/withRouter"
import Slider from "rc-slider"
import "rc-slider/assets/index.css"
import {
  Row,
  ButtonGroup,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Card,
  CardBody,
  Col,
} from "reactstrap"
import ListPageHeader from "../../components/custom/ListPageHeader"
import ListPage from "../../components/custom/ListPage"
import { ageGroupValidation } from "../../helpers/validations"
import { Message } from "../../helpers/language_helper"
import "react-datepicker/dist/react-datepicker.css"
import { SuccessMessage, ErrorMessage } from "../../helpers/notifications"
import { QueryRequest, MutateRequest } from "../../helpers/service_helper"
import {
  createAgeGroupMasterMutation,
  updateAgeGroupMasterMutation,
  deleteAgeGroupMasterMutation,
  getAllAgeGroupMasterQuery,
  getOneAgeGroupMasterQuery,
} from "./Queries"
import { Helmet } from "react-helmet-async"

const Range = Slider

class AgeGroupMaster extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentpage: 1,
      buttonAction: false,
      isLoading: true,
      pageSizeOptions: [25, 50, 100, 500],
      pageLimit: 25,
      totalCount: 0,
      manageModal: false,
      keyField: "id",
      viewModal: false,
      ageGroupMasterList: [],

      listRequestModel: {
        searchString: "",
        sortCondition: null,
        pageNumber: 1,
        pageLimit: 25,
      },
      ageGroupMaster: {},
      columns: [
        {
          name: "Age Group Title",
          selector: row => row.ageGroupTitle,
          sortable: true,
          cell: row => (
            <span>{row.ageGroupTitle ? row.ageGroupTitle : ""}</span>
          ),
        },
        {
          name: "Lower Age Limit",
          selector: row => row.lowerAgeLimit,
          sortable: true,
          cell: row => <span>{row.lowerAgeLimit ? row.lowerAgeLimit : 0}</span>,
        },
        {
          name: "Upper Age Limit",
          selector: row => row.upperAgeLimit,
          sortable: true,
          cell: row => (
            <span>{row.upperAgeLimit ? row.upperAgeLimit : ""}</span>
          ),
        },
        {
          name: "Action",
          selector: row => row.action,
          sortable: false,
          cell: row => (
            <Row>
              <ButtonGroup className="mb-2" style={{ top: "4px" }}>
                <Button
                  outline
                  color="primary"
                  className="mobileViewFont ms-2"
                  onClick={() => this.handleEdit(row)}
                >
                  {Message("edit")}
                </Button>

                <Button
                  outline
                  color="danger"
                  className="mobileViewFonts ps-1 pe-1 ms-2"
                  onClick={() => this.toggleDeleteModal(row)}
                >
                  {Message("delete")}
                </Button>
              </ButtonGroup>
            </Row>
          ),
        },
      ],
    }
  }

  componentDidMount() {
    this.getAllAgeGroupMaster()
  }
  getAllAgeGroupMaster = async value => {
    this.setState({
      isLoading: true,
    })
    const { listRequestModel } = this.state
    var values = listRequestModel
    const response = await QueryRequest(getAllAgeGroupMasterQuery, values)
    var ageGroupMastersValue = response?.data?.getAllAgeGroupMasters?.items
    if (ageGroupMastersValue) {
      this.setState({
        isLoading: false,
        ageGroupMasterList: ageGroupMastersValue,
        totalPage:
          response?.data?.getAllAgeGroupMasters?.pagination?.totalCount /
          response?.data?.getAllAgeGroupMasters?.pagination?.pageLimit,
        totalCount:
          response?.data?.getAllAgeGroupMasters?.pagination?.totalCount,
      })
    } else
      this.setState({
        isLoading: false,
      })
  }

  /** handle list page  start  */
  handleSort = (column, sortDirection) => {
    var sortObj = {}
    sortObj[column.selector] = sortDirection === "asc" ? "asc" : "desc"
    this.setState(
      {
        listRequestModel: {
          ...this.state.listRequestModel,
          sortCondition: sortObj,
        },
      },
      function () {
        this.getAllAgeGroupMaster()
      }
    )
  }

  handlePerRowsChange = async perPage => {
    this.setState(
      {
        pageLimit: perPage,
        pageNumber: 1,
        listRequestModel: {
          ...this.state.listRequestModel,
          pageLimit: perPage,
          pageNumber: 1,
        },
      },
      async function () {
        this.getAllAgeGroupMaster()
      }
    )
  }

  handlePageChange = async page => {
    this.setState(
      {
        pageNumber: page,
        listRequestModel: {
          ...this.state.listRequestModel,
          pageNumber: page,
        },
      },
      function () {
        this.getAllAgeGroupMaster()
      }
    )
  }

  searchQueryChanged = search => {
    this.setState(
      {
        listRequestModel: {
          ...this.state.listRequestModel,
          searchString: search.target.value,
        },
      },
      function () {
        if (
          this.state.listRequestModel.searchString === "" ||
          this.state.listRequestModel.searchString.length > 2
        ) {
          this.getAllAgeGroupMaster()
        }
      }
    )
  }

  handleEdit = row => {
    if (row) {
      this.setState({
        ageGroupMaster: row,
        manageModal: !this.state.manageModal,
        IsEdited: true,
        Label: "Edit",
      })
    }
  }

  /** Submit Function Start */
  handleSubmit = async values => {
    this.state.Label == "Add" ? this.AddAge(values) : this.EditAge(values)
    // const response = values.id
    //   ? await MutateRequest(updateAgeGroupMasterMutation, values)
    //   : await MutateRequest(createAgeGroupMasterMutation, values)
    // var ageGroupMasterValue = response?.data
    // if (ageGroupMasterValue && values.id) {
    //   SuccessMessage(Message("ageGroupMaster.update")),
    //     this.setState({
    //       manageEditModal: !this.state.manageEditModal,
    //     })
    //   this.getAllAgeGroupMaster()
    // } else {
    //   SuccessMessage(Message("ageGroupMaster.add")),
    //     this.setState({
    //       manageModal: !this.state.manageModal,
    //     })
    //   this.getAllAgeGroupMaster()
    // }
  }
  AddAge = async values => {
    await MutateRequest(createAgeGroupMasterMutation, { data: values })
      .then(res => SuccessMessage(Message("ageGroupMaster.add")))
      .catch(e => ErrorMessage(e))
    this.setState({
      manageModal: !this.state.manageModal,
    })
    this.getAllAgeGroupMaster()
  }

  EditAge = async values => {
    let Data = {
      id: this.state.ageGroupMaster.id,
      data: {
        lowerAgeLimit: values.lowerAgeLimit,
        upperAgeLimit: values.upperAgeLimit,
        ageGroupTitle: values.ageGroupTitle,
      },
    }
    await MutateRequest(updateAgeGroupMasterMutation, Data)
      .then(res => SuccessMessage(Message("ageGroupMaster.update")))
      .catch(e => ErrorMessage(e))
    this.setState({
      manageModal: !this.state.manageModal,
    })
    this.getAllAgeGroupMaster()
  }

  addBtnClick = () => {
    this.setState({
      ageGroupMaster: {
        lowerAgeLimit: 0,
        upperAgeLimit: 30,
        ageGroupTitle: "",
      },
      Label: "Add",
      manageModal: !this.state.manageModal,
    })
  }

  toggleDeleteModal = row => {
    this.setState({
      deleteModal: !this.state.deleteModal,
      ageGroupMaster: row,
    })
  }

  toggleManageModal = () => {
    this.setState({
      ageGroupMaster: {},
      manageModal: !this.state.manageModal,
    })
  }

  deleteAgeGroupMaster = async id => {
    var values = {
      id: id,
    }
    const response = await MutateRequest(deleteAgeGroupMasterMutation, values)
    var ageGroupMasterdeleteValue = response?.data
    if (
      ageGroupMasterdeleteValue.deleteOneAgeGroupMaster.status === "Success"
    ) {
      SuccessMessage(Message("ageGroupMaster.delete"))
      this.getAllAgeGroupMaster()
      this.setState({
        buttonAction: false,
        deleteModal: !this.state.deleteModal,
      })
    } else {
      ErrorMessage(Message("api.error"))
      this.setState({
        buttonAction: false,
      })
    }
  }

  toggleViewModal = url => {
    this.setState({
      viewModal: !this.state.viewModal,
      documentView: url,
      ageGroupMasterDetail: url ? url : "",
    })
  }

  render() {
    const initialValues = this.state.ageGroupMaster
    const conditionalRowStyles = [
      {
        when: row => row,
        style: {
          "&:hover": {
            cursor: "pointer",
          },
        },
      },
    ]
    return (
      <Fragment>
        <Helmet>
          <title>{Message("title.ageGroupMaster")}</title>
        </Helmet>
        <div className="page-content">
          <div className="container-fluid">
            <Card>
              <CardBody>
                <ListPageHeader
                  heading={`${"Home"}.${"Age Groups"}`}
                  buttonText={Message("add.ageGroupMaster")}
                  onTextChange={this.searchQueryChanged}
                  buttonClick={this.addBtnClick}
                  searchValue={this.state.listRequestModel.searchString}
                />
                <Row></Row>

                <ListPage
                  conditionalRowStyles={conditionalRowStyles}
                  columns={this.state.columns}
                  data={this.state.ageGroupMasterList}
                  keyField={this.state.keyField}
                  totalCount={this.state.totalCount}
                  rowClicked={this.HandleRowClicked}
                  pageLimit={this.state.pageLimit}
                  pageSizeOptions={this.state.pageSizeOptions}
                  onSort={this.handleSort}
                  rowsPerPageOnChange={this.handlePerRowsChange}
                  pageChange={this.handlePageChange}
                  isDataLoading={this.state.isLoading}
                  overFlowXRemoval={true}
                />
              </CardBody>
            </Card>
            <Modal
              isOpen={this.state.deleteModal}
              toggle={this.toggleDeleteModal}
            >
              <ModalHeader toggle={this.toggleDeleteModal}>
                {Message("delete.ageGroupMaster")}
              </ModalHeader>

              <ModalBody>
                <Fragment>
                  <Row className="mb-1 mt-2">
                    <p className="ms-3 me-3 font-size-15">
                      {Message("delete.confirmation")}{" "}
                      <span>
                        {" "}
                        <strong>
                          {" "}
                          {this.state.ageGroupMaster?.ageGroupTitle}
                        </strong>{" "}
                        {Message("ageGroup")}{" "}
                      </span>
                      ?
                    </p>
                  </Row>
                </Fragment>
              </ModalBody>

              <ModalFooter>
                <FormGroup className="float-sm-right ">
                  <Button
                    type="submit"
                    color="primary"
                    onClick={() =>
                      this.deleteAgeGroupMaster(this.state.ageGroupMaster.id)
                    }
                  >
                    {Message("yes")}
                  </Button>
                  <Button
                    color="danger"
                    className="ms-2"
                    onClick={() => this.toggleDeleteModal()}
                  >
                    {Message("no")}
                  </Button>
                </FormGroup>
              </ModalFooter>
            </Modal>
            <Modal
              isOpen={this.state.manageModal}
              toggle={this.toggleManageModal}
              size="md"
            >
              <ModalHeader toggle={this.toggleManageModal}>
                {this.state.Label == "Add"
                  ? Message("add.ageGroupMaster")
                  : Message("update.ageGroupMaster")}
              </ModalHeader>
              <Formik
                initialValues={initialValues}
                validationSchema={ageGroupValidation}
                onSubmit={this.handleSubmit}
                validateOnBlur={false}
                validateOnChange={false}
              >
                {({ errors, values, setFieldValue }) => (
                  <Form className="av-tooltip tooltip-label-bottom">
                    <ModalBody>
                      <Fragment>
                        <Row>
                          <Col lg="12" xl="12" sm="12" md="12" xs="12">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label className="requiredField">
                                {" "}
                                {Message("ageGroupTitle")}
                              </Label>

                              <Field
                                autoComplete="off"
                                className="form-control"
                                name="ageGroupTitle"
                                type="text"
                              />
                              {errors.ageGroupTitle && (
                                <div className="invalid-feedback d-block">
                                  {errors.ageGroupTitle}
                                </div>
                              )}
                            </FormGroup>
                          </Col>
                          <Col lg="12" xl="12" sm="12" md="12" xs="12">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label className="requiredField">
                                {Message("ageLimit")}
                              </Label>

                              <br />
                              <Range
                                range
                                className="m-1"
                                min={0}
                                max={30}
                                value={[
                                  values.upperAgeLimit,
                                  values.lowerAgeLimit,
                                ]}
                                onChange={e => {
                                  setFieldValue("upperAgeLimit", e[1])
                                  setFieldValue("lowerAgeLimit", e[0])
                                }}
                                marks={{
                                  0: "0",
                                  5: "5",
                                  10: "10",
                                  15: "15",
                                  20: "20",
                                  25: "25",
                                  30: "30",
                                }}
                              />
                              <br />
                              {errors.lowerAgeLimit && (
                                <div className="invalid-feedback d-block">
                                  {errors.lowerAgeLimit}
                                </div>
                              )}
                              {errors.upperAgeLimit && (
                                <div className="invalid-feedback d-block">
                                  {errors.upperAgeLimit}
                                </div>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                      </Fragment>
                    </ModalBody>

                    <ModalFooter>
                      <div className="container-fluid">
                        <Row>
                          <Col sm={6} className="required">
                            &nbsp;{Message("mandatoryFields")}
                          </Col>
                          <Col sm={6}>
                            <div className="text-sm-right d-none d-sm-block">
                              <FormGroup className="float-sm-right ">
                                <Button type="submit" color="primary">
                                  {this.state.Label == "Edit"
                                    ? "Update"
                                    : "Add"}
                                </Button>

                                <Button
                                  color="danger"
                                  className="ms-2"
                                  onClick={() => this.toggleManageModal()}
                                >
                                  {Message("cancel")}
                                </Button>
                              </FormGroup>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </ModalFooter>
                  </Form>
                )}
              </Formik>
            </Modal>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default withRouter(AgeGroupMaster)
